import { FC } from 'react';
import { Chips } from '@medtronic/pecc-react-component-library-js';
import { Box, Typography } from '@mui/material';
import { ProjectMember, RoleEnum } from '~/api/types';

interface UsernameCellProps {
  member: ProjectMember;
}

const UsernameCell: FC<UsernameCellProps> = ({ member }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem', height: '100%' }}>
    <Typography color="electricBlue.main">{`${member?.first_name} ${member?.last_name}`}</Typography>
    {member?.role_id === RoleEnum.OWNER && (
      <Chips
        chipsConfig={[
          {
            label: 'Project Owner',
          },
        ]}
      />
    )}
  </Box>
);

export default UsernameCell;
